/**
 * FinancialBillingReminders - Página de Régua de Cobrança
 * 
 * Configura lembretes automáticos antes e após o vencimento
 * de cobranças financeiras (módulo de lembretes genérico).
 * 
 * @version 1.0.0
 * RELEASE: 2026-03-29 v1.0.0 - Criação da página
 */

import { Bell } from 'lucide-react';
import { ReminderRulesManager } from '@/components/reminders/ReminderRulesManager';

export default function FinancialBillingReminders() {
  return (
    <div className="space-y-6">
      {/* Componente genérico de regras de lembrete (já inclui header com título + botão) */}
      <ReminderRulesManager
        entityType="cobranca"
        title="Régua de Cobrança"
        description="Envie lembretes antes do vencimento e notificações de atraso automaticamente."
        allowPositiveOffsets={true}
        maxRules={20}
        permissionKey="financial_billing_reminders"
      />
    </div>
  );
}
